export const APP_STATES = {
	LOADING: 'LOADING',
	LIST: 'LIST',
	ERROR: 'ERROR'
};
